// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-dialog-content {
   overflow: scroll;
}

.dialog-container {
   display: flex;
   flex-direction: column;
   min-height: 600px;
}

mat-dialog-actions{
   margin-top: 12px;
   padding-bottom: 15px;
}

.live-search {
   background-color: #fff;
   box-sizing: border-box;
   box-shadow: 0 5px 12px 2px rgba(0,0,0,0.25);
   margin-top: 5px;
   position: absolute;
   width: 345px;
   z-index: 1;
}
.live-search ul {
   list-style: none;
   margin: 0;
   padding: 0;
}
.live-search a {
   cursor: pointer;
   padding: 10px;
}
.live-search a:hover {
   background-color: #f4f5f7;
   text-decoration: none;
}
.live-search img {
   margin-right: 10px;
   object-fit: cover;
   min-width: 32px;
   width: 32px;
   height: 32px;
}
.live-search .name, .live-search .desc {
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
}
.live-search .desc {
   color: #999;
   font-size: 12px;
}
.live-search .not-found {
   padding: 10px 20px;
}

.mat-column-no {
   text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/admin/add-site/add-site.component.css"],"names":[],"mappings":"AAAA;GACG,gBAAgB;AACnB;;AAEA;GACG,aAAa;GACb,sBAAsB;GACtB,iBAAiB;AACpB;;AAEA;GACG,gBAAgB;GAChB,oBAAoB;AACvB;;AAEA;GACG,sBAAsB;GACtB,sBAAsB;GACtB,2CAA2C;GAC3C,eAAe;GACf,kBAAkB;GAClB,YAAY;GACZ,UAAU;AACb;AACA;GACG,gBAAgB;GAChB,SAAS;GACT,UAAU;AACb;AACA;GACG,eAAe;GACf,aAAa;AAChB;AACA;GACG,yBAAyB;GACzB,qBAAqB;AACxB;AACA;GACG,kBAAkB;GAClB,iBAAiB;GACjB,eAAe;GACf,WAAW;GACX,YAAY;AACf;AACA;GACG,gBAAgB;GAChB,uBAAuB;GACvB,mBAAmB;AACtB;AACA;GACG,WAAW;GACX,eAAe;AAClB;AACA;GACG,kBAAkB;AACrB;;AAEA;GACG,kBAAkB;AACrB","sourcesContent":[".mat-dialog-content {\n   overflow: scroll;\n}\n\n.dialog-container {\n   display: flex;\n   flex-direction: column;\n   min-height: 600px;\n}\n\nmat-dialog-actions{\n   margin-top: 12px;\n   padding-bottom: 15px;\n}\n\n.live-search {\n   background-color: #fff;\n   box-sizing: border-box;\n   box-shadow: 0 5px 12px 2px rgba(0,0,0,0.25);\n   margin-top: 5px;\n   position: absolute;\n   width: 345px;\n   z-index: 1;\n}\n.live-search ul {\n   list-style: none;\n   margin: 0;\n   padding: 0;\n}\n.live-search a {\n   cursor: pointer;\n   padding: 10px;\n}\n.live-search a:hover {\n   background-color: #f4f5f7;\n   text-decoration: none;\n}\n.live-search img {\n   margin-right: 10px;\n   object-fit: cover;\n   min-width: 32px;\n   width: 32px;\n   height: 32px;\n}\n.live-search .name, .live-search .desc {\n   overflow: hidden;\n   text-overflow: ellipsis;\n   white-space: nowrap;\n}\n.live-search .desc {\n   color: #999;\n   font-size: 12px;\n}\n.live-search .not-found {\n   padding: 10px 20px;\n}\n\n.mat-column-no {\n   text-align: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
